module.exports = __webpack_public_path__ + "img/update_email_phone.0124f1a9.jpg";